import { render, staticRenderFns } from "./ShopRedPacket.vue?vue&type=template&id=268fc6cb&scoped=true&"
import script from "./ShopRedPacket.vue?vue&type=script&lang=js&"
export * from "./ShopRedPacket.vue?vue&type=script&lang=js&"
import style0 from "./ShopRedPacket.vue?vue&type=style&index=0&id=268fc6cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268fc6cb",
  null
  
)

export default component.exports